import { Grid, Table, Popconfirm, message } from 'antd';
import { ColumnType, TablePaginationConfig } from 'antd/es/table';
import { RecordCountBadge } from 'components';
import { StyledTableHeader, StyledTableWrapper } from 'components/table/table.styled';
import { EventsFilterFormPaginated } from 'features/events';
import { Dispatch, SetStateAction } from 'react';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { useParams, useSearchParams } from 'react-router-dom';

const { useBreakpoint } = Grid;

type EventsTableProps = {
    isLoading: boolean;
    data?: any;
    tableParams: EventsFilterFormPaginated;
    updateParams: Dispatch<SetStateAction<EventsFilterFormPaginated>>;
    refetch: any
    setCouponAmount: any,
    setCouponNo: any
    setCouponCode: any,
};

const UploadDetailsComponentTable = ({
    data,
    isLoading,
    tableParams,
    updateParams,
    refetch,
    setCouponAmount,
    setCouponNo,
    setCouponCode,
}: EventsTableProps) => {
    const handleTableChange = (
        pagination: TablePaginationConfig,
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
        });
    };
    const screens = useBreakpoint();
    const tableWidth = screens.xxl ? { x: 1440 } : { x: 1200 };
    const { id } = useParams()
    const participants = data?.items?.[0]?.ParticipantList_new || [];
    const participantList = data?.items?.[0]?.ParticipantList_new || [];
    const paymentStatus = data?.items?.[0]?.bulk_upload_details?.payment_Status;
    const iSColsed = data?.items?.[0]?.bulk_upload_details
    const [searchParams] = useSearchParams();
    const origin = searchParams.get("origin");
    const originType =
        origin === "BulkUpload" ? "bulkupload" : "groupregistration";
    const onDelete = async (particapntId: any, event_id: any) => {
        try {
            const apires: any = await TransectionApiServices().removeParticipantlist(originType, particapntId, id, event_id)
            // message.success(apires?.ResponseMessage)
            if (apires?.ResponseStatus == 0) {
                message.error(apires?.ResponseMessage)
            } else {
                message.success(apires?.ResponseMessage)
            }
            setCouponAmount(0);
            setCouponNo("")
            setCouponCode(null)
            refetch()
        } catch (error: any) {
            message.error(error)
        }
    }
    const allowByClosed =
        iSColsed?.is_closed_link === false &&
        iSColsed?.is_closed_by_admin === false
    const baseHide =
        paymentStatus === "SUCCESS" ||
        paymentStatus === "PENDING" ||
        participantList.length === 0;
    // 🔹 Dynamically generate all data columns
    // const dynamicColumns: ColumnType<any>[] = participants.length
    //     ? Object.keys(participants[0]).map((key) => ({
    //         title: key,
    //         dataIndex: key,
    //         key: key,
    //         ellipsis: true,
    //         width: 200,
    //         render: (text: any) => text ?? '-',
    //     }))
    //     : [];
    const dynamicColumns: ColumnType<any>[] = participants.length
        ? Object.keys(participants[0])
            .filter((key) => key !== "ParticipantId")   // 👈 HIDE this column
            .map((key) => ({
                title: key,
                dataIndex: key,
                key: key,
                ellipsis: true,
                width: 200,
                render: (text: any) => text ?? '-',
            }))
        : [];
    // 🔹 Add Action column (with delete icon)
    const actionColumn: ColumnType<any> = {
        title: 'Action',
        key: 'action',
        width: 120,
        render: (_, record) => (
            <Popconfirm
                title="Are you sure you want to delete this participant?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => {
                    if (onDelete) {
                        onDelete(record.ParticipantId, record?.EventId);
                    } else {
                        message.warning('Delete handler not implemented');
                    }
                }}
            >
                <span
                    role="button"
                    style={{ cursor: 'pointer', color: 'red' }}
                >
                    Remove
                </span>
            </Popconfirm>
        ),
    };

    // const columnsWithAction =
    //     paymentStatus === "SUCCESS" ||  paymentStatus=="PENDING" || participantList.length === 0
    //         ? dynamicColumns
    //         : [...dynamicColumns, actionColumn];

    const columnsWithAction =
        baseHide || !allowByClosed
            ? dynamicColumns
            : [...dynamicColumns, actionColumn];

    return (
        <div>
            <StyledTableWrapper>
                <StyledTableHeader>
                    <RecordCountBadge
                        text="Participants found"
                        count={data?.items?.[0]?.ParticipantList_new?.length || 0}
                    />
                </StyledTableHeader>

                <Table
                    loading={isLoading}
                    dataSource={participants}
                    rowKey="ParticipantId"
                    onChange={handleTableChange}
                    pagination={{
                        current: tableParams.page,
                        defaultPageSize: tableParams.size,
                        total: data?.total,
                    }}
                    className="event_table"
                    scroll={{ ...tableWidth, x: true }}
                    columns={columnsWithAction}
                />
            </StyledTableWrapper>
        </div>
    );
};

export default UploadDetailsComponentTable;
